import { render, staticRenderFns } from "./OticaComponente.vue?vue&type=template&id=710a79d4&scoped=true"
import script from "./OticaComponente.vue?vue&type=script&lang=js"
export * from "./OticaComponente.vue?vue&type=script&lang=js"
import style0 from "./OticaComponente.vue?vue&type=style&index=0&id=710a79d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710a79d4",
  null
  
)

export default component.exports